<template>
  <div id="cardid" class="card col-12 rounded-3 shadow-sm rounded">
    <div class="">
      <div id="container" class="svg-container"></div>
    </div>
  </div>
</template>
<script>
import * as d3 from "d3";
import TableMatrix from "../../model/TableMatrix";

export default {
  name: "KnowledgeGraph",
  props: ["PreProcessingResult", "AnnotationContent"],
  data() {
    return {
      nodes: [],
      links: [],
      isSimulationOn: true,
      forceProperties: {
        scale: {
          value: 1,
          minX: -400,
          minY: -300,
          maxX: 400,
          maxY: 300
        },
        center: {
           x: 0,
           y: 0
         },
      //   charge: {
      //     enabled: true,
      //     strength: -30,
      //     distanceMin: 100,
      //     distanceMax: 10000
      //   },
      //   collide: {
      //     enabled: true,
      //     strength: .7,
      //     iterations: 1,
      //     radius: 5
      //   },
      //   forceX: {
      //     enabled: false,
      //     strength: .1,
      //     x: .5
      //   },
      //   forceY: {
      //     enabled: false,
      //     strength: .1,
      //     y: .5
      //   },
      //   link: {
      //     enabled: true,
      //     distance: 150,
      //     iterations: 1
      //   }
       },
      forceChargeStrength: -20,
      svg: null,
    };
  },
  computed: {
    displayedPreProcessingResult: function () {
      if ((this.PreProcessingResult !== undefined) && (this.PreProcessingResult[0] !== undefined)) {
        return this.PreProcessingResult[0];
      } else {
        return undefined;
      }
    },
    displayedAnnotationContent: function () {
      if ((this.AnnotationContent !== undefined) && (this.AnnotationContent[0] !== undefined)) {
        return this.AnnotationContent[0];
      } else {
        return undefined;
      }
    },
    CEAArray: function () {
      const returnedCEAArray = [];
      returnedCEAArray[0] = ["Row", "Column", "ID", "Label", "Score"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CEA.forEach(element => {
          const splittedUris = element.annotation.uri.split('::');
          let qid = '';
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            qid += (qid === '') ? '' : '::'
            qid += `${splittedUriHeader}${splittedUriQid}`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = element.annotation.label;
          const lineArray = [element.row, element.column, transformedLabel, label, element.annotation.score.toFixed(2)];
          returnedCEAArray.push(lineArray);
        });
      }
      return returnedCEAArray;
    },
    CPAArray: function () {
      const returnedCPAArray = [];
      returnedCPAArray[0] = ["Head", "Tail", "ID", "Label", "Score", "Coverage"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CPA.forEach(element => {
          const splittedUris = element.annotation.uri.split('::');
          let qid = '';
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            qid += (qid === '') ? '' : '::'
            qid += `${splittedUriHeader}${splittedUriQid}`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = element.annotation.label;
          const lineArray = [element.headColumn, element.tailColumn, transformedLabel, label, element.annotation.score.toFixed(2), element.annotation.coverage.toFixed(2)];
          returnedCPAArray.push(lineArray);
        });
      }
      return returnedCPAArray;
    },
    CTAArray: function () {
      const returnedCTAArray = [];
      returnedCTAArray[0] = ["Column", "ID", "Label", "Score", "Coverage"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CTA.forEach(element => {
          const elementAnnotation = element.annotation[0];
          const splittedUris = elementAnnotation.uri.split('::');
          let qid = '';
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            qid += (qid === '') ? '' : '::'
            qid += `${splittedUriHeader}${splittedUriQid}`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = elementAnnotation.label;
          const lineArray = [element.column, transformedLabel, label, elementAnnotation.score.toFixed(2), elementAnnotation.coverage.toFixed(2)];
          returnedCTAArray.push(lineArray);
        });
      }
      return returnedCTAArray;
    },
    CEATableMatrix: function () {
      return new TableMatrix(this.CEAArray);
    },
    CPATableMatrix: function () {
      return new TableMatrix(this.CPAArray);
    },
    CTATableMatrix: function () {
      return new TableMatrix(this.CTAArray);
    },
    isPreProcessingResultDefined: function () {
      return (this.PreProcessingResult !== undefined) && (Array.isArray(this.PreProcessingResult)) && (this.PreProcessingResult[0] !== undefined);
    },
    PreProcessingResultOrientation: function () {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.tableOrientation.orientationLabel : undefined;
    },
    PreProcessingResultHasHeader: function () {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.hasHeader : undefined;
    },
    PreProcessingResultHeaderPosition: function () {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.headerPosition : undefined;
    },
    PreProcessingResultHeaderLabel: function () {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.headerLabel : undefined;
    },
    PreProcessingResultTableDataRawMatrix: function () {
      return this.isPreProcessingResultDefined ? new TableMatrix(this.PreProcessingResult[0].raw.tableDataRaw) : new TableMatrix(undefined);
    },
    PreProcessingResultPrimitiveTyping: function () {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.primitiveTyping : undefined;
    },
    PreProcessingResultTableDataRevisedMatrix: function () {
      return this.isPreProcessingResultDefined ? new TableMatrix(this.PreProcessingResult[0].preprocessed.tableDataRevised) : new TableMatrix(undefined);
    },
    PreProcessingResultTableDataRevisedWithAnnotationDataMatrix: function () {
      const returnedArray = [];
      this.PreProcessingResultTableDataRevisedMatrix.getRows().forEach((row, rowIndex) => {
        if ((row !== undefined) && (Array.isArray(row))) {
          const returnedRow = [];
          if (rowIndex === this.PreProcessingResultHeaderPosition) {
            row.forEach((columnInRow, columnIndexInRow) => {
              // returnedRow.push(`${columnInRow}`)
              const cta = this.CTATableMatrix.getRows().filter((ctaRow) => {
                return (ctaRow[0] === columnIndexInRow)
              })[0];
              const cpaArray = this.CPATableMatrix.getRows().filter((cpaRow) => {
                return ((cpaRow[0] === columnIndexInRow) || (cpaRow[1] === columnIndexInRow))
              }).map((cpaFiltered) => {
                return {
                  cpaIsDefined: cpaFiltered ? (cpaFiltered[2] && cpaFiltered[4] && cpaFiltered[5] && cpaFiltered[0] && cpaFiltered[1]) : false,
                  cpaLabel: cpaFiltered[3],
                  cpaLinkedColumn: (cpaFiltered[0] === columnIndexInRow) ? cpaFiltered[1] : cpaFiltered[0],
                  cpaLink: cpaFiltered[2],
                  cpaScore: cpaFiltered[4],
                  cpaCoverage: cpaFiltered[5],
                  cpaHead: cpaFiltered[0],
                  cpaTail: cpaFiltered[1]
                };
              });

              const cea = this.CEATableMatrix.getRows().filter((ceaRow) => {
                return ((ceaRow[0] === rowIndex) && (ceaRow[1] === columnIndexInRow))
              })[0];

              returnedRow.push({
                initialText: columnInRow,
                ctaIsMerged: this.isMergeCtaSwitchActive,
                ctaIsDefined: cta && this.isMergeCtaSwitchActive ? (cta[1] && cta[3] && cta[4]) : false,
                ctaLabel: cta && this.isMergeCtaSwitchActive ? cta[2] : undefined,
                ctaLink: cta && this.isMergeCtaSwitchActive ? cta[1] : undefined,
                ctaScore: cta && this.isMergeCtaSwitchActive ? cta[3] : undefined,
                ctaCoverage: cta && this.isMergeCtaSwitchActive ? cta[4] : undefined,
                cpaIsMerged: this.isMergeCpaSwitchActive,
                cpaArray: this.isMergeCpaSwitchActive ? cpaArray : undefined,
                ceaIsMerged: this.isMergeCeaSwitchActive,
                ceaIsDefined: cea && this.isMergeCeaSwitchActive ? (cea[2] && cea[4]) : false,
                ceaLabel: cea && this.isMergeCeaSwitchActive ? cea[3] : undefined,
                ceaLink: cea && this.isMergeCeaSwitchActive ? cea[2] : undefined,
                ceaScore: cea && this.isMergeCeaSwitchActive ? cea[4] : undefined
              });
            });
          } else {
            row.forEach((columnInRow, columnIndexInRow) => {
              // returnedRow.push(`<b>${columnInRow}</b><small>${rowIndex}--${columnIndexInRow}</small><StatusDisplayer status="ANNOTATION DONE"></StatusDisplayer>`)
              const cea = this.CEATableMatrix.getRows().filter((ceaRow) => {
                return ((ceaRow[0] === rowIndex) && (ceaRow[1] === columnIndexInRow))
              })[0];
              returnedRow.push({
                initialText: columnInRow,
                ctaIsMerged: this.isMergeCtaSwitchActive,
                cpaIsMerged: this.isMergeCpaSwitchActive,
                ceaIsMerged: this.isMergeCeaSwitchActive,
                ceaIsDefined: cea && this.isMergeCeaSwitchActive ? (cea[2] && cea[4]) : false,
                ceaLabel: cea && this.isMergeCeaSwitchActive ? cea[3] : undefined,
                ceaLink: cea && this.isMergeCeaSwitchActive ? cea[2] : undefined,
                ceaScore: cea && this.isMergeCeaSwitchActive ? cea[4] : undefined
              })
            });
          }
          returnedArray.push(returnedRow);
        }
      })
      return new TableMatrix(returnedArray);
    },
    dataset: function () {
      let graph = {
        nodes: [],
        links: []
      };

      console.log("[kris] this.PreProcessingResultHeaderLabel = ", this.PreProcessingResultHeaderLabel)

      // This commented code create nodes from headers which can be undefined!
/*
      this.PreProcessingResultHeaderLabel.forEach((label, index) => {
        let node = {
          'id': index,
          'type': 'COLUMN',
          'content': {
            'title': label,
            'primitiveTyping': [],
            'properties': [],
            'labels': [],
            'cea_nodes': [],
            'cea_links': []
          }
        }

        this.PreProcessingResultPrimitiveTyping[index].typing.forEach(typing => {
          node.content.primitiveTyping.push(typing.typingLabel)
        })
        graph.nodes.push(node);

      })
*/

      this.PreProcessingResultPrimitiveTyping.forEach((typingItem, index) => {
        // let label = (this.PreProcessingResultHeaderLabel.length > index) ? this.PreProcessingResultHeaderLabel[index] : '<i># No header #<br/><i>';
        let label = (this.PreProcessingResultHeaderLabel.length > index) ? this.PreProcessingResultHeaderLabel[index] : undefined;
        let node = {
          'id': index,
          'type': 'COLUMN',
          'content': {
            'columnId': '#'+index,
            'title': label,
            'primitiveTyping': typingItem.typing.map(t => t.typingLabel),
            'properties': [],
            'labels': [],
            'cea_nodes': [],
            'cea_links': []
          }
        }
        graph.nodes.push(node);

      })


      this.CPATableMatrix.getRows().forEach((cpaRow, index) => {
        if (index !== 0) {
          let link = {
            'source': {'id': cpaRow[0]},
            'target': {'id': cpaRow[1]},
            'content': cpaRow[2] + ' ' + cpaRow[3]
          }
          graph.links.push(link)
        }

      })

      this.CTATableMatrix.getRows().forEach((ctaRow, index) => {
        if (index !== 0) {
          if (graph.nodes[ctaRow[0]] !== undefined) {
            graph.nodes[ctaRow[0]].content.labels.push(ctaRow[2])
            graph.nodes[ctaRow[0]].content.properties.push(ctaRow[1])
          }
        }

      })

      let nextNodeIndex = graph.nodes.length;

      this.CEATableMatrix.getRows().forEach((ceaRow, index) => {
        if (index !== 0) {
          let node = {
            'id': nextNodeIndex,
            'type': 'CELL',
            'content': {
              'title': 'Row ' + ceaRow[0] + ' Col ' + ceaRow[1],
              'properties': [ceaRow[2]],
              'labels': [ceaRow[3]],
            }
          };
          let link = {
            'source': {'id': nextNodeIndex},
            'target': {'id': ceaRow[1]},
            'content': ''
          }
          if (graph.nodes[ceaRow[1]] !== undefined) {
            graph.nodes[ceaRow[1]].content.cea_nodes.push(node);
            graph.nodes[ceaRow[1]].content.cea_links.push(link);
          }
          nextNodeIndex++;

        }

      })


      return graph;
    }
  },
  watch: {
    forceProperties: {
      handler() {
        this.updateForces();
      },
      deep: true
    },
    isSimulationOn: {
      handler() {
        if (this.isSimulationOn) {
          this.node.each(d => {
            d.fx = null;
            d.fy = null;
          });
        } else {
          this.node.each(d => {
            d.fx = d.x;
            d.fy = d.y;
          });
        }

      },
      deep: true
    }
  },
  async mounted() {
    this.dataset.nodes.forEach(e => this.nodes.push(e));
    this.dataset.links.forEach(l => {
      let source = this.nodes.filter(n => n.id === l.source.id)[0];
      let target = this.nodes.filter(n => n.id === l.target.id)[0];
      this.links.push({
        "source": source,
        "target": target,
        "content": l.content
      });
    })
    this.svg = d3.select("div#container")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        // .attr("viewBox", [
        //   this.forceProperties.scale.minX / this.forceProperties.scale.value,
        //   this.forceProperties.scale.minY / this.forceProperties.scale.value,
        //   (this.forceProperties.scale.maxX - this.forceProperties.scale.minX) / this.forceProperties.scale.value,
        //   (this.forceProperties.scale.maxY - this.forceProperties.scale.minY) / this.forceProperties.scale.value])//
          .attr("viewBox", [
          this.forceProperties.scale.minX / this.forceProperties.scale.value,
          this.forceProperties.scale.minY / this.forceProperties.scale.value,
          (this.forceProperties.scale.maxX - this.forceProperties.scale.minX) / this.forceProperties.scale.value,
          (this.forceProperties.scale.maxY - this.forceProperties.scale.minY) / this.forceProperties.scale.value])
        .classed("svg-content", true)
        .call(d3.zoom().on("zoom",this.zoom));

    this.simulation = d3.forceSimulation(this.nodes);
    this.simulation.force("center", d3.forceCenter())
    this.simulation.force("link", d3.forceLink(this.links).distance(500));
    this.simulation.force("charge", d3.forceManyBody().strength(this.forceChargeStrength))
        .force("x", d3.forceX())
        .force("y", d3.forceY());
    this.color = d3.scaleOrdinal(d3.schemeCategory10);
    this.simulation.alphaTarget(1);
    this.simulation.on("tick", this.ticked);

    this.link = this.svg.append("g")
        .attr('class', 'links-content')
        .selectAll(".links-content")
    this.node = this.svg.append("g")
        .attr('class', 'nodes-content')
        .selectAll(".nodes-content");
    this.linkLabel = this.svg.append("g")
        .attr('class', 'linklabels-content')
        .selectAll(".linklabels-content");

    d3.timeout(this.reScale, 100);
    d3.timeout(this.simulation.stop, 200);

    this.restart();

    this.node.on("dblclick", this.doubleClick);
    this.link.on("mouseover", this.onMouseOver);
    this.svg.append("svg:defs").selectAll("marker")
        .data(["end"])
        .enter().append("svg:marker")
        .attr("id", String)
        .attr("viewBox", "0 -5 10 10")
        .attr("refX", 10)
        .attr("refY", 0)
        .attr("markerWidth", 20)
        .attr("markerHeight", 30)
        .attr("orient", "auto")
        .attr("fill", "grey")
        .append("svg:path")
        .attr("d", "M0,-5L10,0L0,5");
  },
  methods: {
    zoom(e) {

      //console.log(JSON.stringify( e))

      if ( this.forceProperties.scale.value == e.transform.k) {
        this.forceProperties.scale.minX -= e.transform.x * this.forceProperties.scale.value;
        this.forceProperties.scale.maxX -= e.transform.x * this.forceProperties.scale.value;
        this.forceProperties.scale.minY -= e.transform.y * this.forceProperties.scale.value;
        this.forceProperties.scale.maxY -= e.transform.y * this.forceProperties.scale.value;
      } else {
        this.forceProperties.scale.value = e.transform.k;

      }
      this.svg.attr("viewBox", [
      this.forceProperties.scale.minX / this.forceProperties.scale.value,
      this.forceProperties.scale.minY / this.forceProperties.scale.value,
      (this.forceProperties.scale.maxX - this.forceProperties.scale.minX) / this.forceProperties.scale.value,
      (this.forceProperties.scale.maxY - this.forceProperties.scale.minY) / this.forceProperties.scale.value]);
      d3.timeout(this.simulation.stop, 200);
    },
    restart() {
      this.link = this.link.data(this.links, d => d.source.id + "-" + d.target.id);
      this.link.exit().remove();
      this.link = this.link.enter()
          .append("line")
          .attr("stroke", "grey")
          .attr("stroke-width", 0.4)
          .style("stroke-dasharray", d => {
            if (d.source.type === 'COLUMN') {
              return ("3, 0")
            } else {
              return ("1, 2")
            }
          })
          .attr("marker-end", "url(#end)")
          .classed('link', true)
          .merge(this.link);

      this.node = this.node.data(this.nodes, d => d.id);
      this.node.exit().remove();
      this.node = this.node.enter()
          .append("foreignObject")
          .style('overflow', 'visible')
          // .attr('width', 5)
          // .attr('height', 5)
          .classed('node', true)
          .html(d => {
            switch (d.type) {
              case 'COLUMN':
                // return "<div class='nodecolumnbox' id='node-" + d.id + "'>" + d.content.title + "<br><span style=\"font:0.8em verdana;\">" + d.content.properties + '</span><br>' + d.content.labels + "</div>";
                return `<div class='nodecolumnbox border border-primary d-flex flex-wrap rounded rounded-2 m-0 p-0' id='node-${d.id}'>
                          <div class='border border-white rounded p-0 m-0'>
                            <div class='d-flex align-items-center col-12 p-1'>
                              <span class='columnIdPill rounded-circle bg-light text-muted p-1 small'>
                                ${d.content.columnId}
                              </span>
                              <span class='mx-1 columnTitle ${(d.content.title === undefined) ? "text-light bg-transparent" : ""}'>
                                ${(d.content.title === undefined) ? "--no header--" : d.content.title}
                              </span>
                            </div>
                            <span class="mx-auto col-11 mt-0 columnSeparator"></span>
                            <span class='columnProperties'>
                              ${d.content.properties}
                            </span>
                            <span class='columnLabels'>
                              ${d.content.labels}
                            </span>
                          </div>
                        </div>`;
              case 'CELL':                
                //return "<div class='nodecellbox' id='node-" + d.id + "'>" + d.content.title + '<br>' + d.content.properties + '<br>' + d.content.labels + "</div>";
                return `<div class='nodecellbox' id='node-${d.id}'>
                            <span class='columnTitle'>
                              ${d.content.title}
                            </span>
                          <span class="mx-auto mt-0 columnSeparator"></span>
                          <span class='columnProperties'>
                            ${d.content.properties}
                          </span>
                          <span class='columnLabels'>
                            ${d.content.labels}
                          </span>
                        </div>`;

            }
          })
          .merge(this.node)
          .call(this.drag(this.simulation));

      this.linkLabel = this.linkLabel.data(this.links, d => d.source.id + "-" + d.target.id);
      this.linkLabel.exit().remove();
      this.linkLabel = this.linkLabel.enter()
          .append("text")
          .classed('linklabel', true)
          .html(d => d.content)
          .merge(this.linkLabel);

      // Update and restart the simulation.
      this.simulation.nodes(this.nodes);
      this.simulation.force("link").links(this.links);
      this.simulation.alpha(1).restart();




    },
    connectPoints(link) {

      const sourceMiddle = {
        x: (link.source.x + (link.source.info.width / 2)),
        y: (link.source.y + (link.source.info.height / 2))
      }

      const targetMiddle = {
        x: (link.target.x + (link.target.info.width / 2)),
        y: (link.target.y + (link.target.info.height / 2))
      }

      const xDiff = sourceMiddle.x - targetMiddle.x;
      const yDiff = sourceMiddle.y - targetMiddle.y;

      const xDistance = (xDiff < 0) ? -xDiff : xDiff;
      const yDistance = (yDiff < 0) ? -yDiff : yDiff;

      const returnedPoint = {
        s: {},
        t: {}
      }

      const maxRatio = (7 / 16);
      const sizeRef = (link.source.info.height + link.target.info.height)/2;

      if (xDistance > 2*yDistance) {
        // link is done on left or right side
        if (xDiff > 0) {
          // link is done on left side
          returnedPoint.s.x = link.source.x;
          returnedPoint.t.x = link.target.x + link.target.info.width;
        } else {
          // link is done on right side
          returnedPoint.s.x = link.source.x + link.source.info.width;
          returnedPoint.t.x = link.target.x;
        }
        // console.log("link = ", JSON.stringify(link));
        // let yDistanceOutOfDiv = yDistance - (link.source.info.height / 2) - (link.target.info.height / 2);
        // yDistanceOutOfDiv = (yDistanceOutOfDiv < 0) ? 0 : yDistanceOutOfDiv;

        let yDistanceFromRefPointOfView = yDistance - sizeRef;
        yDistanceFromRefPointOfView = (yDistanceFromRefPointOfView < 0) ? 0 : yDistanceFromRefPointOfView;

        // const yRatio = (yDistanceOutOfDiv > 1) ? (1 - (1/yDistanceOutOfDiv)) : 0;
        // const yRatio = (yDistanceOutOfDiv > ((link.source.info.height + link.target.info.height)/2)) ? (1 - ((link.source.info.height + link.target.info.height)/(2*yDistanceOutOfDiv))) : 0;
        const yRatio = (yDistanceFromRefPointOfView > sizeRef/2) ? (1 - (sizeRef/(2*yDistanceFromRefPointOfView))) : 0;
        if (yDiff > 0) {
          returnedPoint.s.y = sourceMiddle.y - (( link.source.info.height * maxRatio ) * yRatio);
          returnedPoint.t.y = targetMiddle.y + (( link.target.info.height * maxRatio ) * yRatio);
        } else {
          returnedPoint.s.y = sourceMiddle.y + (( link.source.info.height * maxRatio ) * yRatio);
          returnedPoint.t.y = targetMiddle.y - (( link.target.info.height * maxRatio ) * yRatio);
        }
      } else {
        // link is done on top or bottom side
        if (yDiff > 0) {
          // link is done on top side
          returnedPoint.s.y = link.source.y;
          returnedPoint.t.y = link.target.y + link.target.info.height;
        } else {
          // link is done on bottom side
          returnedPoint.s.y = link.source.y + link.source.info.height;
          returnedPoint.t.y = link.target.y;
        }
        //let xDistanceOutOfDiv = xDistance - (link.source.info.height / 2) - (link.target.info.height / 2);
        //xDistanceOutOfDiv = (xDistanceOutOfDiv < 0) ? 0 : xDistanceOutOfDiv;

        let xDistanceFromRefPointOfView = xDistance - sizeRef;
        xDistanceFromRefPointOfView = (xDistanceFromRefPointOfView < 0) ? 0 : xDistanceFromRefPointOfView;

        // const yRatio = (yDistanceOutOfDiv > 1) ? (1 - (1/yDistanceOutOfDiv)) : 0;
        // const xRatio = (xDistanceOutOfDiv > ((link.source.info.width + link.target.info.width)/2)) ? (1 - ((link.source.info.width + link.target.info.width)/(2*xDistanceOutOfDiv))) : 0;
        //const xRatio = (xDistanceOutOfDiv > ((link.source.info.height + link.target.info.height)/2)) ? (1 - ((link.source.info.height + link.target.info.height)/(2*xDistanceOutOfDiv))) : 0;
        const xRatio = (xDistanceFromRefPointOfView > sizeRef) ? (1 - (sizeRef/xDistanceFromRefPointOfView)) : 0;
        if (xDiff > 0) {
          returnedPoint.s.x = sourceMiddle.x - (( link.source.info.width * maxRatio ) * xRatio);
          returnedPoint.t.x = targetMiddle.x + (( link.target.info.width * maxRatio ) * xRatio);
        } else {
          returnedPoint.s.x = sourceMiddle.x + (( link.source.info.width * maxRatio ) * xRatio);
          returnedPoint.t.x = targetMiddle.x - (( link.target.info.width * maxRatio ) * xRatio);
        }
      }

      return returnedPoint;
    },
    connectPointsV1(link) {

      // const sourceCenterPoint = {
      //   x: link.source.x + link.source.info.width / 2,
      //   y: link.source.y + link.source.info.height / 2
      // };
      const targetCenterPoint = {
        x: link.target.x + link.target.info.width / 2,
        y: link.target.y + link.target.info.height / 2
      };
      const sourceXArray = [link.source.x,
        (link.source.x + 1 * link.source.info.width / 4),
        (link.source.x + link.source.info.width / 2),
        (link.source.x + 3 * link.source.info.width / 4),
        (link.source.x + link.source.info.width)
      ];
      const sourceYArray = [link.source.y,
        (link.source.y + link.source.info.height / 4),
        (link.source.y + link.source.info.height / 2),
        (link.source.y + 3 * link.source.info.height / 4),
        (link.source.y + link.source.info.height)
      ];
      const targetXArray = [link.target.x,
        (link.target.x + 1 * link.target.info.width / 4),
        (link.target.x + link.target.info.width / 2),
        (link.target.x + 3 * link.target.info.width / 4),
        link.target.x + link.target.info.width
      ];
      const targetYArray = [link.target.y,
        (link.target.y + link.target.info.height / 4),
        (link.target.y + link.target.info.height / 2),
        (link.target.y + 3 * link.target.info.height / 4),
        (link.target.y + link.target.info.height),
      ]
      const sourceConnectPoints = [
        // {x: sourceXArray[0], y: sourceYArray[0]},
        // {x: sourceXArray[0], y: sourceYArray[4]},
        // {x: sourceXArray[4], y: sourceYArray[0]},
        // {x: sourceXArray[4], y: sourceYArray[4]},
        {x: sourceXArray[0], y: sourceYArray[1]},
        {x: sourceXArray[0], y: sourceYArray[2]},
        {x: sourceXArray[0], y: sourceYArray[3]},
        {x: sourceXArray[1], y: sourceYArray[0]},
        {x: sourceXArray[1], y: sourceYArray[4]},
        {x: sourceXArray[2], y: sourceYArray[0]},
        {x: sourceXArray[2], y: sourceYArray[4]},
        {x: sourceXArray[3], y: sourceYArray[0]},
        {x: sourceXArray[3], y: sourceYArray[4]},
        {x: sourceXArray[4], y: sourceYArray[1]},
        {x: sourceXArray[4], y: sourceYArray[2]},
        {x: sourceXArray[4], y: sourceYArray[3]}];
      const targetConnectPoints = [
        // {x: targetXArray[0], y: targetYArray[0]},
        // {x: targetXArray[0], y: targetYArray[4]},
        // {x: targetXArray[4], y: targetYArray[0]},
        // {x: targetXArray[4], y: targetYArray[4]},
        {x: targetXArray[0], y: targetYArray[1]},
        {x: targetXArray[0], y: targetYArray[2]},
        {x: targetXArray[0], y: targetYArray[3]},
        {x: targetXArray[1], y: targetYArray[0]},
        {x: targetXArray[1], y: targetYArray[4]},
        {x: targetXArray[2], y: targetYArray[0]},
        {x: targetXArray[2], y: targetYArray[4]},
        {x: targetXArray[3], y: targetYArray[0]},
        {x: targetXArray[3], y: targetYArray[4]},
        {x: targetXArray[4], y: targetYArray[1]},
        {x: targetXArray[4], y: targetYArray[2]},
        {x: targetXArray[4], y: targetYArray[3]}];
      const d = function d(p, center) {
        return Math.sqrt(Math.pow(p.x - center.x, 2) + Math.pow(p.y - center.y, 2))
      }

      let sourceClossestConnectPoint = sourceConnectPoints.reduce((a, b) => d(a, targetCenterPoint) < d(b, targetCenterPoint) ? a : b);
      let targetClossestConnectPoint = targetConnectPoints.reduce((a, b) => d(a, sourceClossestConnectPoint) < d(b, sourceClossestConnectPoint) ? a : b);

      return {s: sourceClossestConnectPoint, t: targetClossestConnectPoint}
    },
    computeLinkX1(link) {
      if ((link.source.info) && (link.target.info)) {
        return this.connectPoints(link).s.x;
      } else {
        return link.source.x;
      }
    },
    computeLinkY1(link) {
      if ((link.source.info) && (link.target.info)) {
        return this.connectPoints(link).s.y;
      } else {
        return link.source.y;
      }
    },
    computeLinkX2(link) {
      if ((link.source.info) && (link.target.info)) {
        return this.connectPoints(link).t.x;
      } else {
        return link.target.x;
      }
    },
    computeLinkY2(link) {
      if ((link.source.info) && (link.target.info)) {
        return this.connectPoints(link).t.y;
      } else {
        return link.target.y
      }
    },
    ticked() {
      this.svg.selectAll('.node')
          .attr("transform", d => `translate(${d.x},${d.y})`);

      this.svg.selectAll('.link').attr("x1", this.computeLinkX1)
          .attr("y1", this.computeLinkY1)
          .attr("x2", this.computeLinkX2)
          .attr("y2", this.computeLinkY2);

      this.linkLabel
          .attr('transform', d => {
            let xOffset = 0;
            let yOffset = 15;
            if (d.source.info) {
              let connectPoints = this.connectPoints(d);
              let x1 = connectPoints.s.x
              let y1 = connectPoints.s.y
              let x2 = connectPoints.t.x
              let y2 = connectPoints.t.y
              let angle = Math.atan((y2 - y1) / (x2 - x1) ) * 180 / Math.PI;
              if ( x2 < x1) {
                //return 'translate(0, 3) rotate(' + angle + ' ' + (x1 + 9*(x2-x1) / 10 )+ ' ' + (y1 + 9*(y2 -y1) / 10 )+ ')';
                return 'rotate(' + angle + ' ' + (x1 + 9*(x2-x1) / 10 )+ ' ' + (y1 + 9*(y2 -y1) / 10 )+ ') translate(' + xOffset + ', ' + yOffset + ')';
              } else {
                //return 'translate(0, 3) rotate(' + angle + ' ' + (x1 + (x2-x1) / 10 )+ ' ' + (y1 + (y2 -y1) / 10 )+ ')';
                return 'rotate(' + angle + ' ' + (x1 + (x2-x1) / 10 )+ ' ' + (y1 + (y2 -y1) / 10 )+ ') translate(' + xOffset + ', ' + yOffset + ')';
              }
            } else {
              let angle = Math.atan((d.target.y - d.source.y) / (d.target.x - d.source.x) ) * 180 / Math.PI;
              return 'rotate(' + angle + ' ' + ((d.source.x + d.target.x) / 2) + ' ' + ((d.source.y + d.target.y) / 2) + ') translate(' + xOffset + ', ' + yOffset + ')';
            }
          })
          .attr("x", d => {
            if (d.source.info) {
              let connectPoints = this.connectPoints(d);
              let x1 = connectPoints.s.x
              let x2 = connectPoints.t.x
              if ( x2 < x1) {
                return x1 + 9*(x2-x1) / 10
              } else {
                return x1 + (x2-x1) / 10;
              }
            } else {
              return ((d.source.x + d.target.x) / 2);
            }
          })
          .attr("y", d => {
            if (d.source.info) {
              let connectPoints = this.connectPoints(d);
              let x1 = connectPoints.s.x
              let x2 = connectPoints.t.x
              let y1 = connectPoints.s.y
              let y2 = connectPoints.t.y
              if ( x2 < x1) {
                return y1 + 9* (y2 -y1) / 10;
              } else {
              return y1 + (y2 -y1) / 10;              }
            } else {
              return ((d.source.y + d.target.y) / 2);
            }
          })

    },
    onMouseOver(event, link) {
      console.log(event)
      console.log(link)
    },
    doubleClick(event, node) {
      if (node.isShown) {
        console.log('hide')
        node.content.cea_nodes.forEach(n => {
          this.removeNode(n);
          let link = node.content.cea_links.filter(l => (l.source.id === n.id))
          if (link.length == 1) {
            this.removeLink({source: n, target: node, content: link[0].content});
          }
        })
        node.isShown = false;
      } else {
        node.content.cea_nodes.forEach(n => {
          this.addNode(n);
          let link = node.content.cea_links.filter(l => (l.source.id === n.id))
          if (link.length == 1) {
            this.addLink({source: n, target: node, content: link[0].content});
          }
        })
        node.isShown = true;
      }
      d3.timeout(this.reScale, 100);
      this.restart();
    },
    addNode(node) {
      this.nodes.push(node);
    },
    addLink(link) {
      this.links.push(link);
    },
    removeNode(node) {
      this.nodes = this.nodes.filter(n => n.id !== node.id);
    },
    removeLink(link) {
      this.links = this.links.filter(l => !((l.source.id === link.source.id) && (l.target.id === link.target.id)));
    },
    updateForces() {
      // this.svg.attr("viewBox", [
      //   this.forceProperties.scale.minX,
      //   this.forceProperties.scale.minY,
      //   (this.forceProperties.scale.maxX - this.forceProperties.scale.minX) / this.forceProperties.scale.value,
      //   (this.forceProperties.scale.maxY - this.forceProperties.scale.minY) / this.forceProperties.scale.value]);
       this.height = this.forceProperties.scale.maxY - this.forceProperties.scale.minY;
      this.width = this.forceProperties.scale.maxX - this.forceProperties.scale.minX;
      this.simulation.force("center")
          .x(this.forceProperties.center.x)
          .y(this.forceProperties.center.y);
      this.simulation.alpha(1).restart();
    },
    reScale() {
      // Calcul des coordonnées des nodes dans la viewBox
      let svg = document.getElementsByClassName('svg-content')[0];
      this.node.each(d => {
        let nodeBoundingClientRect = d3.select('#node-' + d.id).node().getBoundingClientRect();

        let topLeftPointScreenCoordinates = svg.createSVGPoint();
        topLeftPointScreenCoordinates.x = nodeBoundingClientRect.x;
        topLeftPointScreenCoordinates.y = nodeBoundingClientRect.y
        console.log('[DEBUG] topLeftPointScreenCoordinates.x ' + topLeftPointScreenCoordinates.x)
        console.log('[DEBUG] topLeftPointScreenCoordinates.y ' + topLeftPointScreenCoordinates.y)


        let bottomRightPointScreenCoordinates = svg.createSVGPoint();
        bottomRightPointScreenCoordinates.x = nodeBoundingClientRect.right;
        bottomRightPointScreenCoordinates.y = nodeBoundingClientRect.bottom;
        console.log('[DEBUG] bottomRightPointScreenCoordinates.x ' + bottomRightPointScreenCoordinates.x)
        console.log('[DEBUG] bottomRightPointScreenCoordinates.y ' + bottomRightPointScreenCoordinates.y)

        let topLeftPointInViewBox = topLeftPointScreenCoordinates.matrixTransform(svg.getScreenCTM().inverse());
        let bottomRightPointInViewBox = bottomRightPointScreenCoordinates.matrixTransform(svg.getScreenCTM().inverse());
        d.info = {
          width: bottomRightPointInViewBox.x - topLeftPointInViewBox.x,
          height: bottomRightPointInViewBox.y - topLeftPointInViewBox.y,
        }
        console.log('[DEBUG] d.info ' + JSON.stringify(d.info))

      })

      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;
      this.node.each(d => {
        if (d.x < minX) minX = d.x;
        if (d.x > maxX) maxX = d.x;
        if (d.y < minY) minY = d.y;
        if (d.y > maxY) maxY = d.y;
      })
      this.forceProperties.scale.minX = minX;
      this.forceProperties.scale.minY = minY;
      this.forceProperties.scale.maxX = maxX + 60;
      this.forceProperties.scale.maxY = maxY + 30;

      // this.svg.attr("viewBox", [
      //   this.forceProperties.scale.minX,
      //   this.forceProperties.scale.minY,
      //   (this.forceProperties.scale.maxX - this.forceProperties.scale.minX) / this.forceProperties.scale.value,
      //   (this.forceProperties.scale.maxY - this.forceProperties.scale.minY) / this.forceProperties.scale.value]);
      //this.simulation.on("end", null);
      console.log('[DEBUG] this.forceProperties.scale.minX ' + this.forceProperties.scale.minX)
      console.log('[DEBUG] this.forceProperties.scale.minY ' + this.forceProperties.scale.minY)
      console.log('[DEBUG] this.forceProperties.scale.maxX ' + this.forceProperties.scale.maxX)
      console.log('[DEBUG] this.forceProperties.scale.maxY ' + this.forceProperties.scale.maxY)
    },
    drag(simulation) {
      function dragstarted(event, d) {
        if (!event.active) simulation.alphaTarget(0.1).restart();
        d.fx = d.x;
        d.fy = d.y;
      }
      function dragged(event, d) {
        d.fx = event.x;
        d.fy = event.y;
      }
      function dragended(event) {
        if (!event.active) simulation.alphaTarget(0);
        // if (this.isSimulationOn) {
        //   d.fx = null;
        //   d.fy = null;
        // }
        simulation.stop();
      }
      return d3.drag()
          .on("start", dragstarted)
          .on("drag", dragged)
          .on("end", dragended);
    }
  }
}
</script>
<style scoped>
.svg-container {
  display: inline;
  position: relative;
  width: 100%;
  overflow: hidden;
}

/deep/ .columnTitle {
  font-size: 0.75rem;
}

/deep/ .columnSeparator {
  border-top: 0.05rem solid;
  display: block;
  margin-bottom: 0.5rem;
}

/deep/ .columnProperties {
  font-size: 0.45rem;
  display: block;
}

/deep/ .columnLabels {
  font-size: 0.6rem;
  display: block;
  margin-bottom: 0.5rem;
}

/deep/ a {
  color: white;
}

/deep/ a:visited {
  color: white
}

/deep/ a:hover {
  color: white
}

/deep/ a:visited {
  color: white
}

/deep/ .linklabel {
  fill: grey;
  font: 0.6rem Verdana;
}

/deep/ .linklabel:hover {
  fill: black;
  font: 0.6rem Verdana;
}

/deep/ .node {
  width: 2rem;
  height: 2rem;
}

/deep/ .nodecolumnbox {
  font: 1rem verdana;
  text-align: center;
  color: #FFF;
  border-radius: 1px;
  background-color: #ff7900;
  padding: 0px;
  position: absolute;
  white-space: nowrap;
  overflow: auto;
  padding-right: 2px;
  padding-left: 2px;
  display: block;
}

/deep/ .nodecellbox {
  font: 1rem verdana;
  text-align: center;
  color: #FFF;
  border-radius: 1px;
  background-color: #0079FF;
  padding: 0px;
  position: absolute;
  white-space: nowrap;
  overflow: auto;
  padding-right: 2px;
  padding-left: 2px;
}

/deep/ .columnIdPill {
  font-size: 0.5rem;
}

.svg-content {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
}

.controls {
  flex-basis: 200px;
  padding: 0 5px;
}

.controls .force {
  background-color: #eee;
  border-radius: 3px;
  padding: 5px;
  margin: 5px 0;
}

.controls .force p label {
  margin-right: .5em;
  font-size: 120%;
  font-weight: bold;
}

.controls .force p {
  margin-top: 0;
}

.controls .force label {
  display: inline-block;
}

.controls input[type="checkbox"] {
  transform: scale(1.2, 1.2);
}

.controls input[type="range"] {
  margin: 0 5% 0.5em 5%;
  width: 90%;
}

/* SVG styles */
svg {
  flex-basis: 100%;
  min-width: 200px;
}

.links line {
  stroke: black;
}
</style>
